import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { SelectItem, LazyLoadEvent, ConfirmationService } from 'primeng';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IPageResult } from '../../interfaces/page-result';
import { ITradePlate } from '../../interfaces/trade-plate';
import { ITradePlateFilter } from '../../interfaces/trade-plate-filter';
import { LoggerService } from '../../services';
import { SupplierService } from '../../services';
import { TaggedLogger } from '../../services';
import { TradePlateService } from '../../services';
import { flatten } from '../../utils/flatten';
import { InputHelper } from '../../utils/input.helper';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';

@Component({
  templateUrl: './trade-plate.component.html',
  providers: [InputHelper, ConfirmationService],
})
export class TradePlateComponent implements OnInit {
  private readonly logger: TaggedLogger;
  msgs: Message[] = [];

  public tradePlate: ITradePlate = { id: 0 };

  displayDialog: boolean = false;
  selectedItem: any;
  suppliers: SelectItem[] = [];

  public page: IPageResult<ITradePlate> = {
    items: [],
    total: 0,
  };

  public isLoaded: boolean = false;
  public filterVal: ITradePlateFilter;
  public filter: Subject<ITradePlateFilter>;
  public numberExp = new RegExp(/^([a-zA-Z]{1}\d{4})$|^(\d{5})$|^(\d{3}[a-zA-Z]{1,3})$/);

  constructor(
    private router: Router,
    private tradePlateService: TradePlateService,
    private supplierService: SupplierService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public inputHelper: InputHelper,
    loggerService: LoggerService,
  ) {
    this.logger = loggerService.taggedLogger('component:trade-plate');
  }

  ngOnInit() {
    this.initSuppliers();

    this.initDefaultFilter();
    this.filter = new Subject<ITradePlateFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.logger.trace('filterVal:', f);
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 100,
      sortField: '',
      sortOrder: 1,
      filters: {
        number: { value: null },
        organisationName: { value: null },
      },
    };
  }

  load(filter: ITradePlateFilter) {
    this.logger.trace('load()', filter);
    this.tradePlateService.getPage(flatten(filter)).then((result) => {
      this.logger.trace('load():', result);
      if (result) {
        this.page.items = result.items;
        this.page.total = result.total;
      }

      this.isLoaded = true;
    });
  }

  // todo: duplicated everywhere.
  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    // map grid lazy load event to filter
    this.filter.next(this.filterVal);
  }

  search() {
    this.load(this.filterVal);
  }

  clearFilter() {
    this.initDefaultFilter();
    this.search();
  }

  showDialogToAdd() {
    this.tradePlate = { id: 0 };
    this.displayDialog = true;
  }

  save(item) {
    this.displayDialog = false;
    this.tradePlateService
      .save(item)
      .then((res) => {
        this.load(this.filterVal);
      })
      .catch((e) => {
        this.messageService.add(
          Message.Error('Trade Plate with same number already exists.', 'Trade Plate'),
        );
      });
  }

  close() {
    this.displayDialog = false;
  }

  downloadToCSV() {
    this.logger.debug('Download CSV Clicked');
    return this.tradePlateService.downloadToCSV(this.filterVal);
  }

  onEdit(item) {
    this.tradePlate = Object.assign({}, item);
    this.displayDialog = true;
  }

  enableDisableUser(item) {
    this.tradePlateService
      .enableDisable(item)
      .then((res) => {
        this.load(this.filterVal);
        this.displayDialog = false;
      })
      .catch((e) => {
        this.messageService.add(Message.Error('Error while enable or disable', 'Trade Plate'));
      });
  }

  initSuppliers() {
    this.supplierService.getAll().then((res) => {
      this.suppliers = [];
      this.suppliers.push({ label: 'Select supplier...', value: null });
      res.forEach((x) => this.suppliers.push({ label: x.name, value: x.id }));
    });
  }

  isValidNumber(number) {
    return this.numberExp.test(number);
  }
}
